import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Story from "@/components/Story";
import FeaturedBuilds from "@/components/FeaturedBuilds";
import Inquiry from "@/components/Inquiry";
import Footer from "@/components/Footer";

const Landing = () => {
  return (
    <main className="relative bg-[#0A0A0A] text-zinc-100 font-body" data-testid="landing-page">
      <Nav />
      <Hero />
      <Marquee />
      <Story />
      <FeaturedBuilds />
      <Inquiry />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
